import { BootstrapIcon, FileExtension, FileType } from '@shared/types/dev';

export abstract class IconUtils {
  public static getIconByExtension(extension: FileExtension): BootstrapIcon {
    switch (extension) {
      case '.jpg':
      case '.jpeg':
      case '.png':
      case '.gif':
      case '.tiff':
      case '.bmp':
      case '.svg':
      case '.webp':
        return 'bi bi-file-image';
      case '.pdf':
        return 'bi bi-file-pdf-fill';
      case '.doc':
      case '.docx':
      case '.odt':
        return 'bi bi-file-earmark-word-fill';
      case '.xls':
      case '.xlsx':
      case '.ods':
        return 'bi bi-file-earmark-spreadsheet-fill';
      case '.ppt':
      case '.pptx':
      case '.odp':
        return 'bi bi-file-earmark-slides-fill';
      case '.mp3':
      case '.wav':
      case '.ogg':
      case '.m4a':
      case '.flac':
      case '.weba':
        return 'bi bi-file-music-fill';
      case '.mp4':
      case '.webm':
      case '.ogv':
      case '.mov':
      case '.avi':
      case '.wmv':
        return 'bi bi-file-earmark-play-fill';
      case '.zip':
      case '.tar':
      case '.gz':
      case '.rar':
      case '.7z':
        return 'bi bi-file-earmark-zip-fill';
    }
  }
  public static getIconByFileType(type: FileType): BootstrapIcon {
    switch (type) {
      case 'image/jpeg':
        return 'bi bi-file-image';
      case 'image/png':
        return 'bi bi-file-image';
      case 'image/gif':
        return 'bi bi-file-image';
      case 'image/tiff':
        return 'bi bi-file-image';
      case 'image/bmp':
        return 'bi bi-file-image';
      case 'image/svg+xml':
        return 'bi bi-file-image';
      case 'image/webp':
        return 'bi bi-file-image';
      case 'application/pdf':
        return 'bi bi-file-pdf-fill';
      case 'audio/mpeg':
        return 'bi bi-file-music-fill';
      case 'audio/wav':
        return 'bi bi-file-music-fill';
      case 'audio/ogg':
        return 'bi bi-file-music-fill';
      case 'audio/mp4':
        return 'bi bi-file-music-fill';
      case 'audio/x-flac':
        return 'bi bi-file-music-fill';
      case 'audio/webm':
        return 'bi bi-file-music-fill';
      case 'video/mp4 ':
        return 'bi bi-file-earmark-play-fill';
      case 'video/webm ':
        return 'bi bi-file-earmark-play-fill';
      case 'video/ogg ':
        return 'bi bi-file-earmark-play-fill';
      case 'video/quicktime ':
        return 'bi bi-file-earmark-play-fill';
      case 'video/x-msvideo ':
        return 'bi bi-file-earmark-play-fill';
      case 'video/x-ms-wmv ':
        return 'bi bi-file-earmark-play-fill';
      case 'application/zip':
      case 'application/x-tar':
      case 'application/gzip':
      case 'application/vnd.rar':
      case 'application/x-7z-compressed':
        return 'bi bi-file-earmark-zip-fill';
    }
  }
}
